<app-out-of-office-status-page-form
  (submitStatus)="submitStatus($event)"
  [users]="users"
  [editedStatus]="editedStatus"
></app-out-of-office-status-page-form>
<app-error-alert
  title="{{ 'statusError' | transloco }}"
  [errors]="submitErrors"
></app-error-alert>
